import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useMaintenanceModel } from "../maintenanceModel";
import { IMaintenanceDetail } from "../../maintenanceType";
import { momentFormat, momentFormats, repairFormatNum } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

type statusType = {
    "maintenance.return-visit": string, //已回访
    "maintenance.write-off": string, //已结款
    "maintenance.underway": string,//在修
    "maintenance.await": string,//待修
    "maintenance.trans": string,//已转接
    "maintenance.stock-io": string,//已出库
    "maintenance.settle": string,//已结算
    "maintenance.create": string,//已开单
    "maintenance.change": string,//已作废
    // "maintenance.create": string,    
    "maintenance.completed": string,
    "maintenance-status.final": string,
    "maintenance.under-review": string,//审核中
    "maintenance.approved": string,//审核通过


    [key: string]: any
}
const statusColor: statusType = {
    "maintenance.return-visit": 'lime', //已回访
    "maintenance.write-off": "green", //已结款
    "maintenance.underway": "geekblue",//在修
    "maintenance.await": "purple",//待修
    "maintenance.trans": "cyan",//已转接
    "maintenance.stock-io": "magenta",//已出库
    "maintenance.settle": "gold",//已结算
    "maintenance.create": "blue",//已开单
    "maintenance.change": "red",//已作废
    "maintenance.completed": "green",//已完工,
    "maintenance-status.final": "pink",//已终检,
    "maintenance.under-review": "geekblue",//审核中
    "maintenance.approved": "green",//审核通过
}

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows, loading, rowsDescTotal, descTotal,
        loadData, setSelectedRowKeys, setDescRows,
    } = useMaintenanceModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData()
    }, [])

    const onLook = (code: string) => {
        let supplierEditKey = "4-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", parentInfo: { selectedNavId } },
            true
        );
    }
    const defaultColumns: ColumnsType<IMaintenanceDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '滞留时间',
            width: 110,
            align: "center",
            dataIndex: 'keepTime',
        }, {
            title: '工单单号',
            width: 120,
            dataIndex: 'maintenanceCode',
            render: (text: any) => <YhTootip text={text} onClick={() => onLook(text)} />,
        }, {
            title: '工单状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        }, {
            title: '客户名称',
            width: 150,
            dataIndex: 'customerName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '车牌号',
            width: 90,
            dataIndex: 'licensePlate',
            render: (text: any) => <YhTootip text={text} style={{ width: 90 }} />,
        }, {
            title: '车辆品牌',
            width: 160,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: '160px' }} />,
        }, {
            title: '车辆类型',
            width: 150,
            dataIndex: 'vehicleTypeName',
            render: (text: any) => <YhTootip text={text} style={{ width: '150px' }} />,
        }, {
            title: '维修类型',
            width: 100,
            dataIndex: 'serviceNatureName',
            render: (text: any) => <YhTootip text={text} style={{ width: 100 }} />,
        }, {
            title: '预计完工时间',
            width: 140,
            dataIndex: 'expectedCompletionTime',
            render: (text: any, record: any) => {
                // 格式化时间
                const formattedTime = text ? momentFormat(text) : '';
                // 判断是否需要标红
                const shouldHighlight = formattedTime && isWithin24Hours(formattedTime, record);

                return (
                    <span style={{ color: shouldHighlight ? "#EF5350" : "" }}>
                        {formattedTime}
                    </span>
                );
            }
        }, {
            title: '派工人',
            width: 80,
            dataIndex: 'dispatcher',
            render: (text: any) => <YhTootip text={text} style={{ width: 100 }} />,
        },
        // {
        //     title: '维修负责人',
        //     width: 120,
        //     dataIndex: '',
        //     render: (text: any, r) =>
        //         r.serviceNatureCode == 'repair-type.003' ||
        //             r.serviceNatureCode == 'repair-type.002' ||
        //             r.serviceNatureCode == 'repair-type.001' ? '康金枝' :
        //             r.serviceNatureCode == 'repair-type.008' ||
        //                 r.serviceNatureCode == 'repair-type.007' ||
        //                 r.serviceNatureCode == 'repair-type.006' ||
        //                 r.serviceNatureCode == 'repair-type.005' ||
        //                 r.serviceNatureCode == 'repair-type.004' ? '由文锁' : '',
        // }, 
        {
            title: '维修工',
            width: 120,
            dataIndex: 'technicianNames',
            render: (text: any) => <YhTootip text={text} style={{ width: 120 }} />,
        }, {
            title: '制单时间',
            width: 150,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '进厂时间',
            width: 150,
            dataIndex: 'enterTime',
            render: (text) => momentFormats(text)
        }, {
            title: '派工时间',
            width: 150,
            dataIndex: 'dispatchTime',
            render: (text: any, record: any,) => momentFormats(record.dispatchTime),
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "order", "roleCodes": roles };
        return getRoleColumns("order", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (record: IMaintenanceDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const onRightClick = (record: IMaintenanceDetail) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    const isWithin24Hours = (expectedTime: any, record: any) => {
        // 如果没有预计时间，不标红
        if (!expectedTime) return false;

        // 如果单据已完工，不标红
        const isCompleted = record.status == 'maintenance.completed' || record.status == 'maintenance.settle' || record.status == 'maintenance-status.final';

        if (isCompleted) return false;

        // 转换为时间戳（毫秒）
        const expected = new Date(expectedTime).getTime();
        const now = new Date().getTime();
        const twentyFourHours = 24 * 60 * 60 * 1000; // 86400000毫秒

        // 时间在当前时间之后且小于24小时
        return expected > now && expected - now < twentyFourHours;
    }
    return (
        <Table
            bordered
            loading={loading}
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMaintenanceDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showSizeChanger: true,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                // onClick: () => onRow(record.id as string),
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    // setSelectedRowKeys([record.id as string]);
                    onRightClick(record)

                }
            })}
            scroll={{ x: "max-content", y: 'calc(100vh - 370px)' }}
        />
    )
}
